import React from 'react'
import { T } from '@transifex/react'
import classNames from 'classnames'
import { useSaleManager } from '../../../ng-compat/hooks'
import { useAppSelector } from '../../../state/hooks'
import { selectSaleNote } from '../../../state/slices/currentSale/currentSaleSlice'
import { useFormatCurrencyValue } from './useFormatCurrencyValue'

export const TotalSavingsSection = () => {
  const saleManager = useSaleManager()
  const formatCurrencyValue = useFormatCurrencyValue()
  const totalSavings = saleManager.getTotalSavings()
  const saleNote = useAppSelector(selectSaleNote)

  return (
    <section
      className={classNames(
        'sale-summary-section sale-summary-section-divider-btm',
        { 'sale-summary-section-divider-top': !saleNote }
      )}
    >
      <div className="sale-summary-line">
        <div className="vd-text-signpost">
          <T
            _str="Total Savings"
            _context="Total savings in sale receipt preview"
          />
        </div>
        <div className="sale-summary-line-item--value vd-text-intro">
          {formatCurrencyValue(totalSavings)}
        </div>
      </div>
    </section>
  )
}
